<template>
    <div class="attendance_wrap">
        <div class="attendance_top_tab">
            <el-tabs v-model="tabActiveName" @tab-click="handleClickTab">
                <el-tab-pane label="考勤记录" name="attendance">
                    <div class="page-tab_wrap">
                        <template v-if="hasLookDashboardPermission">
                            <div class="page-filter_wrap">
                                <div class="page-filter_wrap_left">
                                    <el-date-picker
                                        v-model="searchForm.date"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        placeholder="请选择日期"
                                        size="small"
                                        :clearable="true"
                                        @change="getDashboard"
                                        @clear="getDashboard"
                                    >
                                    </el-date-picker>
                                </div>
                            </div>
                            <ul class="page-card_wrap">
                                <li>
                                    <span>{{ dashboardData.total_employees }}人</span>
                                    <span>公司总人数</span>
                                </li>
                                <li>
                                    <span>{{ dashboardData.present_employees }}人</span>
                                    <span>出勤总人数</span>
                                </li>
                                <li>
                                    <span>{{ dashboardData.travel_employees }}人</span>
                                    <span>出差人数</span>
                                </li>
                                <li>
                                    <span>{{ dashboardData.overtime_employees }}人</span>
                                    <span>加班人数</span>
                                </li>
                                <li>
                                    <span>{{ dashboardData.leave_employees }}人</span>
                                    <span>请假人数</span>
                                </li>
                            </ul>
                        </template>
                        <div class="page-filter_wrap">
                            <div class="page-filter_wrap_left">
                                <!-- <el-input
                                    v-model="searchForm.keyWord"
                                    class="filter-input"
                                    clearable
                                    placeholder="请输入员工姓名"
                                    @clear="handleClickSearch"
                                    @keyup.enter.native="handleClickSearch"
                                >
                                    <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                                </el-input> -->
                                <el-select
                                    clearable
                                    placeholder="请输入员工姓名"
                                    size="small"
                                    v-model="searchForm.uid"
                                    collapse-tags
                                    filterable
                                    remote
                                    :remote-method="getUserList"
                                    @change="handleClickSearch"
                                >
                                    <el-option
                                        :key="user.uid"
                                        :label="user.name"
                                        :value="user.uid"
                                        v-for="user in userList"
                                    >
                                    </el-option>
                                </el-select>
                                <el-select
                                    class="filter-input"
                                    placeholder="请选择部门"
                                    size="small"
                                    ref="department_select"
                                    v-model="searchForm.department"
                                    :remote-method="getDepartmentList"
                                    filterable
                                    remote
                                    reserve-keyword
                                    :clearable="true"
                                    @clear="handleClickClearDepartment"
                                >
                                    <el-option :value="[]" style="height: auto; padding: 0">
                                        <el-tree
                                            :data="departmentList"
                                            :expand-on-click-node="false"
                                            :props="{ children: 'children', label: 'relate_name' }"
                                            @node-click="handleClickDepNode"
                                            check-on-click-node
                                            check-strictly
                                            default-expand-all
                                            node-key="id"
                                            ref="depTree"
                                            size="mini"
                                        >
                                        </el-tree>
                                    </el-option>
                                </el-select>
                                <el-date-picker
                                    v-model="searchForm.dateRange"
                                    type="daterange"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    range-separator="至"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间"
                                    size="small"
                                    :clearable="false"
                                    @change="handleClickSearch"
                                >
                                </el-date-picker>
                            </div>
                            <div class="page-filter_wrap_right">
                                <el-button
                                    type="primary"
                                    size="small"
                                    :loading="exportBtnDisabled"
                                    :disabled="exportBtnDisabled"
                                    v-auth="'attendance.getAttendanceTableExport'"
                                    permission_type="person"
                                    route_name="Attendance"
                                    @click="handleClickExport"
                                    >导出</el-button
                                >
                            </div>
                        </div>
                        <div class="page-tab_table_wrap" v-loading="tableLoading">
                            <CustomVxeTable
                                v-if="tabActiveName == 'attendance'"
                                ref="tableRef"
                                :customConfig="tableCustomConfig"
                                :empty-render="{ name: 'NotData' }"
                                :isShowToolBar="true"
                                :pagination.sync="pagination"
                                :reduceHeight="reduceHeight"
                                :tableData="tableData"
                                @handleCurrentChange="handleCurrentChange"
                                @handleSizeChange="handleSizeChange"
                                @selection-change="selectionChange"
                            >
                                <vxe-column
                                    v-for="(item, index) in fieldsList"
                                    :key="item.field_key"
                                    :align="
                                        item.field_key === 'name' || item.field_key === 'department_id'
                                            ? 'left'
                                            : 'right'
                                    "
                                    :field="item.field_key"
                                    :show-overflow="item.field_key === 'name' ? false : true"
                                    :title="item.field_value"
                                    :min-width="item.table_column_width"
                                    :fixed="item.field_key === 'name' ? 'left' : ''"
                                >
                                    <template #header>
                                        <div class="table_field_label">
                                            <span
                                                v-text="
                                                    item.field_key === 'name' || item.field_key === 'department_id'
                                                        ? item.field_value
                                                        : item.field_value + '（天）'
                                                "
                                            ></span>
                                        </div>
                                    </template>
                                    <template #default="{ row }">
                                        <template v-if="item.field_key == 'name'">
                                            <PersonnelCard :userId="row.uid" v-if="row.uid && row.name">
                                                <template slot="container">
                                                    <div class="user-avatar-btn" v-if="row.name">
                                                        <img :src="row.avatar ? row.avatar : defaultImg" alt="" />
                                                        <span>{{ row.name }}</span>
                                                    </div>
                                                </template>
                                            </PersonnelCard>
                                            <span v-else>--</span>
                                        </template>
                                        <template v-else-if="item.field_key == 'department_id'">
                                            <el-tooltip
                                                :content="
                                                    row.department_path ? row.department_path : row.department_name
                                                "
                                                effect="dark"
                                                placement="top-start"
                                                v-if="row.department_name"
                                            >
                                                <span v-text="row.department_name"></span>
                                            </el-tooltip>
                                            <span v-else>--</span>
                                        </template>
                                        <template v-else>
                                            <div>
                                                <span
                                                    v-if="row[item.field_key] !== null"
                                                    :class="{
                                                        'link-label': item.type,
                                                    }"
                                                    @click="handleClickDayDetail(item, row)"
                                                    >{{ row[item.field_key] }}</span
                                                >
                                                <span v-else>--</span>
                                            </div>
                                        </template>
                                    </template>
                                </vxe-column>
                                <template #empty>
                                    <div class="custom-table-empty">
                                        <div class="custom-table-empty-img">
                                            <img src="https://download.hecoos.com/enlightv/2025-09/79aca5659d09f1a8f1161d7106c3ecf6.png" alt="">
                                        </div>
                                        <p class="custom-table-empty-txt">暂无数据</p>
                                    </div>
                                </template>
                            </CustomVxeTable>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="打卡记录" name="clockIn">
                    <div class="page-tab_wrap">
                        <div class="page-filter_wrap">
                            <div class="page-filter_wrap_left">
                                <!-- <el-date-picker
                                    v-model="searchForm.date"
                                    type="month"
                                    format="yyyy-MM"
                                    value-format="yyyy-MM"
                                    placeholder="请选择时间"
                                    size="small"
                                >
                                </el-date-picker> -->
                                <el-date-picker
                                    :picker-options="pickerOptions"
                                    @change="handleClickSearch"
                                    align="right"
                                    size="small"
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd"
                                    range-separator="-"
                                    start-placeholder="开始日期"
                                    type="daterange"
                                    unlink-panels
                                    v-model="searchForm.calc_date"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                >
                                </el-date-picker>
                                <el-input
                                    v-model="searchForm.keyWord"
                                    class="filter-input"
                                    clearable
                                    placeholder="请输入员工姓名"
                                    @clear="handleClickSearch"
                                    @keyup.enter.native="handleClickSearch"
                                >
                                    <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                                </el-input>
                                <el-popover placement="bottom-start" width="500" trigger="click">
                                    <div class="search_container">
                                        <div class="search_top_container">
                                            <span class="title">筛选</span>
                                            <el-button
                                                @click="handleClickReset"
                                                size="mini"
                                                :disabled="
                                                    searchFilterList.findIndex(item => ((Array.isArray(item.field_value) && item.field_value.length) || (!Array.isArray(item.field_value) && item.field_value !== undefined)) ) > -1
                                                        ? false
                                                        : true
                                                "
                                                >清空筛选条件</el-button
                                            >
                                        </div>
                                        <div class="search_bottom_container">
                                            <ul>
                                                <li v-for="item in searchFilterList">
                                                    <div>
                                                        <el-select size="small" v-model="item.field_key" disabled>
                                                            <el-option
                                                                label="部门"
                                                                value="department_id_list"
                                                            ></el-option>
                                                            <el-option label="打卡次数" value="punch_times"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div class="search_filter_type">
                                                        <template v-if="item.field_key == 'department_id_list'">
                                                            <el-select size="small" v-model="item.field_type" disabled>
                                                                <el-option label="满足" value="eq"></el-option>
                                                                <el-option label="不满足" value="neq"></el-option>
                                                            </el-select>
                                                        </template>
                                                        <template v-else>
                                                            <el-select size="small" v-model="item.field_type" @change="handleClickSearch">
                                                                <el-option label="大于" value="GT"></el-option>
                                                                <el-option label="小于" value="LT"></el-option>
                                                            </el-select>
                                                        </template>
                                                    </div>
                                                    <div>
                                                        <template v-if="item.field_key == 'department_id_list'">
                                                            <el-select
                                                                ref="depSelect"
                                                                v-model="item.department_title"
                                                                multiple
                                                                placeholder="请选择部门"
                                                                clearable
                                                                collapse-tags
                                                                size="small"
                                                                @clear="handleClickClearDepartmentClockIn(item)"
                                                                @remove-tag="handleRemoveDepartmentTag(item)"
                                                            >
                                                                <el-option :value="[]" style="height: auto; padding: 0">
                                                                    <el-tree
                                                                        :ref="`dep_select_tree1`"
                                                                        :data="departmentList"
                                                                        :expand-on-click-node="false"
                                                                        :props="{
                                                                            children: 'children',
                                                                            label: 'relate_name',
                                                                        }"
                                                                        show-checkbox
                                                                        check-on-click-node
                                                                        check-strictly
                                                                        default-expand-all
                                                                        highlight-current
                                                                        node-key="relate_id"
                                                                        size="mini"
                                                                        @check-change="
                                                                            (data, checked, indeterminate) =>
                                                                                handleDepartmentCheckChange(
                                                                                    data,
                                                                                    checked,
                                                                                    indeterminate,
                                                                                    item
                                                                                )
                                                                        "
                                                                    >
                                                                    </el-tree>
                                                                </el-option>
                                                            </el-select>
                                                        </template>
                                                        <template v-else>
                                                            <el-input-number
                                                                v-model="item.field_value"
                                                                :controls="false"
                                                                placeholder="请输入"
                                                                size="small"
                                                                @blur="handleClickSearch"
                                                            >
                                                            </el-input-number>
                                                        </template>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <el-button size="small" slot="reference" class="custom_popover_button">
                                        <i class="iconfont icon-shaixuan"></i>
                                        <span
                                            class="search_filter_length"
                                            v-if="searchFilterList.filter((item) => ((Array.isArray(item.field_value) && item.field_value.length) || (!Array.isArray(item.field_value) && item.field_value !== undefined))).length"
                                        >
                                            <span
                                                v-text="
                                                    searchFilterList.filter((item) => ((Array.isArray(item.field_value) && item.field_value.length) || (!Array.isArray(item.field_value) && item.field_value !== undefined))).length +
                                                    '个条件'
                                                "
                                            ></span>
                                            <i class="el-icon-error" @click="handleClickReset"></i>
                                        </span>
                                    </el-button>
                                </el-popover>
                                <el-checkbox v-model="searchForm.filter_empty_user" @change="handleClickSearch"
                                    >仅查看有打卡记录的人员</el-checkbox
                                >
                            </div>
                            <div class="page-filter_wrap_right">
                                <el-button type="primary" size="small"  
                                    v-auth="'attendance.getAdminAttendanceCheckExport'"
                                    permission_type="person"
                                    route_name="Attendance">导出</el-button>
                            </div>
                        </div>
                        <div class="page-tab_table_wrap">
                            <CustomVxeTable
                                v-if="tabActiveName == 'clockIn'"
                                ref="tableRef2"
                                :customConfig="tableCustomConfig"
                                :empty-render="{ name: 'NotData' }"
                                :isShowToolBar="false"
                                :pagination.sync="paginationClockIn"
                                :reduceHeight="reduceHeightClockIn"
                                :tableData="tableDataClockIn"
                                @handleCurrentChange="handleCurrentChangeClockIn"
                                @handleSizeChange="handleSizeChangeClockIn"
                                @selection-change="selectionChangeClockIn"
                            >
                                <vxe-column field="name" title="姓名" fixed="left" width="150">
                                    <template #default="{ row }">
                                        <PersonnelCard :userId="row.uid" v-if="row.uid && row.name">
                                                <template slot="container">
                                                    <div class="user-avatar-btn" v-if="row.name">
                                                        <img :src="row.avatar ? row.avatar : defaultImg" alt="" />
                                                        <span>{{ row.name }}</span>
                                                    </div>
                                                </template>
                                            </PersonnelCard>
                                            <span v-else>--</span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="name2" title="部门" min-width="130">
                                    <template #default="{ row }">
                                        <span>{{ row.department_name }}</span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="name3" title="打卡天数" min-width="80">
                                    <template #default="{ row }">
                                        <span class="link-label" @click="handleClickClockInRecordDetail(row)">{{
                                            row.punch_days
                                        }}</span>
                                    </template>
                                </vxe-column>
                                <vxe-column field="name4" title="打卡次数" min-width="150">
                                    <template #default="{ row }">
                                        <span class="link-label" @click="handleClickClockInRecordDetail(row)">{{
                                            row.punch_times
                                        }}</span>
                                    </template>
                                </vxe-column>
                                <vxe-column
                                    v-for="(item, index) in clockInTableHeaders"
                                    :key="item.field_key"
                                    :field="item.field_key"
                                    :show-overflow="true"
                                    :title="item.field_label"
                                    :min-width="150"
                                >
                                    <template #default="{ row }">
                                        <span
                                            class="link-label"
                                            v-if="row[item.field_key]"
                                            @click="handleClickDayClockInRecordDetail(row, item.field_key)"
                                            >{{ row[item.field_key] }}</span
                                        >
                                        <span v-else>--</span>
                                    </template>
                                </vxe-column>
                                <template #empty>
                                    <div class="custom-table-empty">
                                        <div class="custom-table-empty-img">
                                            <img src="https://download.hecoos.com/enlightv/2025-09/79aca5659d09f1a8f1161d7106c3ecf6.png" alt="">
                                        </div>
                                        <p class="custom-table-empty-txt">暂无数据</p>
                                    </div>
                                </template>
                            </CustomVxeTable>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <leaveDaysDetails
            :dialogVisible.sync="dialogVisible"
            :leaveType.sync="leaveType"
            :dateRange="searchForm.dateRange"
            :userName="userName"
            :uid="uid"
            :holiday_config_id="holiday_config_id"
            v-if="dialogVisible"
        />
        <clockInRecordDetails
            v-if="clockInRecordDialogVisible"
            :clockInRecordDialogVisible.sync="clockInRecordDialogVisible"
            :userName="individualName"
            :queryParams="queryParams"
        />
    </div>
</template>

<script>
import * as XLSX from "xlsx";
import { GetDepartmentList, GetDashboard, GetAttendanceTable, GetUserList, GetAdminAttendanceCheck , GetAttendanceTableExport, getAdminAttendanceCheckExport} from "@/api";
import { pagination } from "@/mixins";
import { formatDate, getDatesBetween } from "@/utils";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import leaveDaysDetails from "./component/leave_days_details.vue";
import ClockInRecordDetails from "./component/clockIn_record_details.vue";
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
import {mapGetters, mapState} from "vuex";
export default {
    name: "Attendance",
    components: { CustomVxeTable, leaveDaysDetails, ClockInRecordDetails, PersonnelCard },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            tabActiveName: "attendance",
            searchForm: {
                date: "",
                keyWord: "",
                dateRange: [],
                filter_empty_user: false,
                department: "",
                department_id: "",
                uid: "",
                calc_date: [],
            },
            departmentList: [],
            dashboardData: {
                total_employees: 0,
                present_employees: 0,
                leave_employees: 0,
                travel_employees: 0,
                overtime_employees: 0,
            },
            tableLoading: false,
            tableData: [], // 考勤记录列表
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "name";
                },
                allowSort: true,
            },
            // reduceHeight: this.hasLookDashboardPermission ? 372 : 218,
            fieldsList: [], // 筛选字段
            systemFilterFields: [],
            // 请假明细
            dialogVisible: false,
            leaveType: "", // leave=请假，overtime=加班，travel=出差
            uid: "",
            userName: "",
            holiday_config_id: "", // 请假类型单个的需要传
            exportBtnDisabled: false,
            userList: [],
            // 打卡
            paginationClockIn: {
                pageNum: 1,
                pageSizes: [15, 30, 50, 100],
                pageSize: 15,
                total: 0,
                layout: "total, prev, pager, next, sizes, jumper",
            }, // 打卡记录分页
            reduceHeightClockIn: 218,
            clockInTableHeaders: [],
            tableDataClockIn: [], // 打卡记录
            clockInRecordDialogVisible: false, // 打卡记录详情
            individualName: "",
            queryParams: {},
            pickerOptions: {
                shortcuts: [
                    {
                        text: "本月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(end.getFullYear(), end.getMonth(), 1);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const start = new Date();
                            start.setMonth(Math.floor(start.getMonth() / 3) * 3, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(start);
                            end.setMonth(start.getMonth() + 3, 0);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "本年",
                        onClick(picker) {
                            const start = new Date(new Date().getFullYear(), 0, 1);
                            start.setHours(0, 0, 0, 0);

                            const end = new Date(new Date().getFullYear(), 11, 31);
                            end.setHours(23, 59, 59, 999);

                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            // 筛选条件
            searchFilterList: [
                {
                    field_key: "department_id_list",
                    field_name: "部门",
                    field_value: [],
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "punch_times",
                    field_name: "打卡次数",
                    field_value: undefined,
                    field_value_name: "",
                    field_type: "GT",
                },
            ],
        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return this.hasLookDashboardPermission ? 372 : 218     
        },
        ...mapGetters(['hasPermission']),
        // 考勤记录上方数据看板区域权限
        hasLookDashboardPermission() {
            return this.hasPermission('attendance.getDashboard', 'person', 'Attendance');
        },

    },
    created() {
        if(this.$route.query && this.$route.query.tab) {
            this.tabActiveName = this.$route.query.tab
        }
        this.searchForm.date = formatDate(new Date(), "date");
        const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        this.searchForm.dateRange = [formatDate(firstDayOfMonth, "date"), formatDate(new Date(), "date")];
        this.searchForm.calc_date = [formatDate(firstDayOfMonth, "date"), formatDate(new Date(), "date")];
        this.getDepartmentList();
        this.handleClickTab();
    },
    methods: {
        // 获取数据看板
        getDashboard() {
            GetDashboard({ date: this.searchForm.date }).then((res) => {
                if (res.code === 200) {
                    this.dashboardData = res.data;
                }
            });
        },
        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];
                }
            });
        },
        handleClickDepNode(data, node, nodeData) {
            this.searchForm.department = data.relate_name;
            this.searchForm.department_id = data.relate_id;
            this.$refs.department_select.handleClose();
            this.handleClickSearch();
        },
        handleClickClearDepartment() {
            this.searchForm.department = "";
            this.searchForm.department_id = "";
            this.handleClickSearch();
        },
        handleClickTab() {
            if (this.tabActiveName == "attendance") {
                // 考勤记录
                this.getDashboard();
                this.getTableData();
            } else {
                // 打卡记录
                this.getCustomDateTableHeader();
                this.getTableDataClockIn();
            }
        },
        // 搜索
        handleClickSearch() {
            if (this.tabActiveName == "attendance") {
                this.pagination.pageNum = 1;
                this.getTableData();
            } else {
                this.getCustomDateTableHeader();
                this.paginationClockIn.pageNum = 1;
                this.getTableDataClockIn();
            }
        },
        // 表格复选框
        selectionChange(ids) {},
        // 查看请假加班明细
        handleClickDayDetail(headerConfig, row) {
            if(headerConfig.type) {
                this.leaveType = headerConfig.type;
                this.uid = row.uid;
                this.userName = row.name;
                this.holiday_config_id = headerConfig.holiday_config_id;
                this.dialogVisible = true;
            }
        },
        // 筛选条件数据
        getFilterData() {},
        // 页码改变-考勤
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        // 页数改变-考勤
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize;
            this.getTableData();
        },
        // 考勤表格
        getTableData() {
            this.tableLoading = true;
            let params = {
                start_date:
                    this.searchForm.dateRange && this.searchForm.dateRange.length ? this.searchForm.dateRange[0] : "",
                end_date:
                    this.searchForm.dateRange && this.searchForm.dateRange.length ? this.searchForm.dateRange[1] : "",
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            if (this.searchForm.uid !== "") {
                params.uid = this.searchForm.uid;
            }
            if (this.searchForm.department_id !== "") {
                params.department_id = this.searchForm.department_id;
            }
            GetAttendanceTable(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { data, headers, total } = res.data;
                        this.fieldsList = headers || [];
                        this.calculateTableWidth(this.fieldsList);
                        this.tableData = data || [];
                        this.pagination.total = total;
                    }
                    this.tableLoading = false;
                })
                .catch(() => {
                    this.tableLoading = false;
                });
        },
        // 计算文本宽度
        calculateTableWidth(field_list, textData) {
            field_list.forEach((item) => {
                if (item.field_key == "name" || item.field_key == "actual_attendance_days") {
                    this.$set(item, "table_column_width", 150);
                } else if (item.field_key == "department_id") {
                    this.$set(item, "table_column_width", 130);
                } else if (item.field_key == "expected_attendance_days") {
                    this.$set(item, "table_column_width", 136);
                } else {
                    this.$set(item, "table_column_width", 122);
                }
            });
        },
        // 复选框
        selectionChangeClockIn(ids) {},
        parseDate(dateStr) {
            const parts = dateStr.split(/[-/]/);
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // 月份从 0 开始
            const day = parseInt(parts[2], 10);
            return new Date(year, month, day);
        },
        // 获取当前是周几
        getWeekday(dateStr) {
            const date = this.parseDate(dateStr);
            const weekdays = ["（日）", "（一）", "（二）", "（三）", "（四）", "（五）", "（六）"];
            return weekdays[date.getDay()];
        },
        // 获取自定义时间表头
        getCustomDateTableHeader() {
            let tableHeaders = [];
            if (this.searchForm.calc_date && this.searchForm.calc_date.length) {
                // 获取日期数组
                const dates = getDatesBetween(this.searchForm.calc_date[0], this.searchForm.calc_date[1]);

                tableHeaders = dates.map((date) => {
                    // date.toLocaleDateString("zh-CN", { year: "numeric", month: "2-digit", day: "2-digit" })
                    return {
                        field_key: formatDate(date, "date"),
                        field_label: formatDate(date, "month") + this.getWeekday(formatDate(date, "date")),
                    };
                });
            }
            this.clockInTableHeaders = tableHeaders;
        },
        // 查看某个人员的打卡记录明细
        handleClickClockInRecordDetail(row) {
            this.individualName = row.name;
            this.queryParams = {
                uid: row.uid,
                // calc_month: "2025-02", //calc_month 不能和calc_start_date、calc_end_date同时传，要么传月份，要么传自定义时间
                calc_start_date:
                    this.searchForm.calc_date && this.searchForm.calc_date.length ? this.searchForm.calc_date[0] : "",
                calc_end_date:
                    this.searchForm.calc_date && this.searchForm.calc_date.length ? this.searchForm.calc_date[1] : "",
            };
            this.clockInRecordDialogVisible = true;
        },
        // 查看某个人员的某天的打卡记录明细
        handleClickDayClockInRecordDetail(row, date) {
            this.individualName = row.name;
            this.queryParams = {
                uid: row.uid,
                // calc_month: "2025-02", //calc_month 不能和calc_start_date、calc_end_date同时传，要么传月份，要么传自定义时间
                calc_start_date: date,
                calc_end_date: date,
            };
            this.clockInRecordDialogVisible = true;
        },
        // 页码改变-打卡
        handleCurrentChangeClockIn(val) {
            this.paginationClockIn.pageNum = val;
            this.getTableDataClockIn();
        },
        // 页数改变-打卡
        handleSizeChangeClockIn(page) {
            this.paginationClockIn.pageNum = 1;
            this.paginationClockIn.pageSize = page.pageSize;
            this.getTableDataClockIn();
        },
        // 打卡表格
        getTableDataClockIn() {
            this.loading = true;
            let params = {
                page: this.paginationClockIn.pageNum,
                limit: this.paginationClockIn.pageSize,
                // calc_month: "2025-02", //calc_month 不能和calc_start_date、calc_end_date同时传，要么传月份，要么传自定义时间
                calc_start_date:
                    this.searchForm.calc_date && this.searchForm.calc_date.length ? this.searchForm.calc_date[0] : "",
                calc_end_date:
                    this.searchForm.calc_date && this.searchForm.calc_date.length ? this.searchForm.calc_date[1] : "",
                uid_list: [],
                department_id_list: [],
                filter_empty_user: this.searchForm.filter_empty_user ? 1 : 0, // 是否仅查看有记录的人员 1是0否
            };
            this.searchFilterList.forEach((item) => {
                if(item.field_key == 'department_id_list') {
                    if(Array.isArray(item.field_value) && item.field_value.length) {
                        params[item.field_key] = item.field_value
                    }
                } else if(item.field_key === 'punch_times') {
                    if(item.field_value !== undefined) {
                        params['punch_operator'] = item.field_type
                        params[item.field_key] = item.field_value
                    }
                }
            });
            GetAdminAttendanceCheck(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { list, total } = res.data;
                        this.tableDataClockIn = list || [];
                        this.paginationClockIn.total = total;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取人员
        getUserList(keyword) {
            GetUserList({ keyword }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        // 导出考勤记录
        handleClickExport() {
            this.exportBtnDisabled = true;
            let tableData = [];
            let HeaderInfo = [];
            let params = {
                start_date:
                    this.searchForm.dateRange && this.searchForm.dateRange.length ? this.searchForm.dateRange[0] : "",
                end_date:
                    this.searchForm.dateRange && this.searchForm.dateRange.length ? this.searchForm.dateRange[1] : "",
                page: 1,
                pageSize: this.pagination.total,
            };
            if (this.searchForm.uid !== "") {
                params.uid = this.searchForm.uid;
            }
            if (this.searchForm.department_id !== "") {
                params.department_id = this.searchForm.department_id;
            }
            GetAttendanceTableExport(params)
                .then((res) => {
                    if (res.code === 200) {
                        const { data, headers, total } = res.data;
                        let newHeaders = [headers[0], {
                            field_key: "phone",
                            field_value: "手机号",
                            name: "手机号"
                        }, ...headers.splice(1)]
                        HeaderInfo = (newHeaders || []).map((item) =>
                            item.type ? item.field_value + "（天）" : item.field_value
                        );
                        tableData = data.map((item) => {
                            let itemdata = [];
                            newHeaders.forEach((field) => {
                                if(field.field_key === 'department_id') {
                                    itemdata.push(item.department_path ? item.department_path : item.department_name);
                                } else {
                                    itemdata.push(item[field.field_key]);
                                }
                            });
                            return itemdata;
                        });
                        // 数据结构
                        // const data = [
                        //     ["姓名", "年龄"],
                        //     ["刘XX", 1],
                        // ];
                        const xlsxData = [HeaderInfo, ...tableData];
                        const ws = XLSX.utils.aoa_to_sheet(xlsxData);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
                        const fileName = this.nowDate();
                        setTimeout(() => {
                            XLSX.writeFile(wb, fileName);
                            this.$message.success("导出成功");
                        }, 2000);
                    }
                    this.exportBtnDisabled = false;
                })
                .catch(() => {
                    this.exportBtnDisabled = false;
                });
        },
        nowDate(type) {
            const today = new Date();
            const year = today.getFullYear();
            let month = today.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            if (type && type == "date") {
                return `${year}-${month}-${date}`;
            } else if (type && type == "date2") {
                return `${year}-${month}`;
            } else {
                return `考勤记录${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
            }
        },
        // 筛选条件清空
        handleClickReset() {
            this.searchFilterList.forEach((item) => {
                if(item.field_key === "department_id_list") {
                    item.department_title = []
                    this.$refs["dep_select_tree1"][0].setCheckedKeys([]);
                }
                this.$set(item, "field_value", item.field_key === "department_id_list" ? [] : undefined);
            });
            this.handleClickSearch();
        },
        // 打卡记录清除部门选择
        handleClickClearDepartmentClockIn(item) {
            item.field_value = [];
            item.department_title = [];
            this.$refs["dep_select_tree1"][0].setCheckedKeys([]);
            this.handleClickSearch()
        },
        // 打卡记录移除多选部门的标签
        handleRemoveDepartmentTag(item) {
            item.field_value.shift();
            const keys = item.field_value.map((item) => item);
            item.field_value = [];
            item.department_title = [];
            this.$refs["dep_select_tree1"][0].setCheckedKeys([]);
            this.$nextTick(() => {
                this.$refs["dep_select_tree1"][0].setCheckedKeys(keys);
            });
            this.handleClickSearch()
        },
        // 打卡记录选择部门事件
        handleDepartmentCheckChange(data, checked, indeterminate, item) {
            if (checked) {
                item.department_title.push(data.relate_name);
                item.field_value.push(data.relate_id);
            } else {
                item.department_title = item.department_title.filter((item) => item !== data.relate_name);
                item.field_value = item.field_value.filter((item) => item !== data.relate_id);
            }
            this.handleClickSearch()
        },
    },
};
</script>

<style lang="scss" scoped>
.attendance_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .attendance_top_tab {
        height: 100%;
        position: relative;
        .el-tabs {
            height: 100%;
        }
        ::v-deep .el-tabs__content {
            height: calc(100% - 48px);
        }
        ::v-deep .el-tab-pane {
            height: 100%;
        }
        ::v-deep .el-tabs__header {
            margin-bottom: 0;
        }
        ::v-deep .el-tabs__nav-wrap::after {
            height: 1px;
            background-color: rgba(232, 232, 232, 1);
        }
        ::v-deep .el-tabs__active-bar {
            display: none;
        }
        ::v-deep .el-tabs__nav {
            padding: 0 16px;
        }
        ::v-deep .el-tabs__item {
            height: 48px;
            line-height: 48px;
            padding: 0 16px !important;
            color: rgba(102, 102, 102, 1);
            font-size: 16px;
            &.is-active {
                color: rgba(41, 144, 255, 1);
                font-weight: bold;
                &:before {
                    height: 2px;
                    opacity: 1;
                    background: rgba(41, 144, 255, 1);
                    content: " ";
                    left: 0;
                    bottom: 1px;
                    position: absolute;
                    width: 100%;
                }
            }
        }
    }
    .page-tab_wrap {
        width: 100%;
        height: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        .page-tab_table_wrap {
            flex: 1;
        }
    }
    .page-card_wrap {
        margin: 16px 0;
        display: flex;
        gap: 16px;
        li {
            flex: 1;
            // max-width: 238px;
            height: 90px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(217, 217, 217, 1);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            span:nth-child(1) {
                font-size: 22px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 32px;
                color: rgba(51, 51, 51, 1);
            }
            span:nth-child(2) {
                margin-top: 8px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 18px;
                color: rgba(102, 102, 102, 1);
            }
        }
    }
    .page-filter_wrap {
        .page-filter_wrap_left {
            align-items: center;
            & > .el-input,
            & > .el-select,
            & > .el-date-editor {
                width: 238px;
            }
            & > .el-checkbox {
                ::v-deep .el-checkbox__label {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(102, 102, 102, 1);
                }
                &.is-checked {
                    ::v-deep .el-checkbox__label {
                        color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }
        .el-date-editor {
            ::v-deep {
                .el-range-separator {
                    width: auto;
                }
            }
        }
    }
}
.search_container {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    .search_top_container {
        display: flex;
        justify-content: space-between;

        span.title {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: bold;
        }

        .el-button {
            padding: 5px 10px;
        }
    }

    .search_bottom_container {
        padding: 16px 0 0px;
        box-sizing: border-box;

        ul {
            width: 100%;

            li {
                width: 100%;
                display: flex;
                margin-bottom: 12px;

                & > div:nth-child(1),
                & > div:nth-child(2) {
                    flex: 1;
                }
                & > div:nth-child(3) {
                    width: 225px;
                    flex-shrink: 0;
                    .el-select {
                        width: 100%;
                    }
                }

                .search_filter_type {
                    margin: 0 8px;
                    width: 86px;
                    max-width: 86px;
                }

                .el-date-editor.el-input {
                    width: 100%;
                    display: block;
                }
                .el-date-editor {
                    width: 100% !important;
                    ::v-deep {
                        .el-range-separator {
                            width: 10%;
                            padding: 0;
                        }
                    }
                }
                .el-input-number {
                    width: 100% !important;
                    ::v-deep {
                        .el-input__inner {
                            text-align: left;
                        }
                    }
                }
            }
        }
    }
}
.custom_popover_button {
    padding: 8px 8px;
    margin-left: 0px;
    i {
        font-size: 14px;
    }
    .search_filter_length {
        margin-left: 8px;
        i {
            margin-left: 8px;
            color: rgba(173, 173, 173, 1);
        }
    }
}
</style>
